import { useEditarConfigDeEnvelopeContext } from "../..";
import OrSpinner from "../../../../../../Components/Utils/OrSpinner";
import {
    IConfigEnvelopeDocumento,
    IInserirConfigEnvelopeDocumento,
} from "../../../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoInterfaces";
import { IDocumentoProduto } from "../../../../../../Interfaces/Geral/Documentos/DocumentoProduto/DocumentoProdutoInterfaces";
import { IDocumentosTemplate } from "../../../../../../Interfaces/Geral/Documentos/DocumentosInterface";
import DocumentoASerInseridoNaConfiguracao from "./DocumentoASerInseridoNaConfiguracao";

type TTipoDocumento = "CONTRATO" | "PRODUTO" | "UNIDADE";
type TKeyTipoDocumento =
    | "documentosContrato"
    | "documentosProduto"
    | "documentosUnidade";
interface ITabelaInserirDocumentoConfigProps {
    tipoDocumento: TTipoDocumento;
}
const objTipoDocumento: Record<
    TTipoDocumento,
    {
        key: TKeyTipoDocumento;
        objBaseGetter: (
            doc: IDocumentosTemplate | IDocumentoProduto
        ) => Omit<
            IInserirConfigEnvelopeDocumento,
            "ID_ENVELOPE_DOCUSIGN_CONFIG"
        >;
        find: (
            docConfig: IConfigEnvelopeDocumento,
            doc: IDocumentosTemplate | IDocumentoProduto
        ) => boolean;
        descricaoGetter: (
            doc: IDocumentosTemplate | IDocumentoProduto
        ) => string;
        tipoDocumentoGetter: (
            doc: IDocumentosTemplate | IDocumentoProduto
        ) => string;
    }
> = {
    CONTRATO: {
        key: "documentosContrato",
        objBaseGetter: (doc) => ({
            ID_DOCUMENTO_TEMPLATE: (doc as IDocumentosTemplate)
                .ID_DOCUMENTO_TEMPLATE,
        }),
        find: (docConfig, doc) =>
            (doc as IDocumentosTemplate).ID_DOCUMENTO_TEMPLATE ===
            docConfig.ID_DOCUMENTO_TEMPLATE,
        descricaoGetter: (doc) => (doc as IDocumentosTemplate).DS_DOCUMENTO,
        tipoDocumentoGetter: (doc) => "Contrato",
    },
    PRODUTO: {
        key: "documentosProduto",
        objBaseGetter: (doc) => ({
            ID_DOCUMENTO_PRODUTO: (doc as IDocumentoProduto)
                .ID_DOCUMENTO_PRODUTO,
        }),
        find: (docConfig, doc) =>
            (doc as IDocumentoProduto).ID_DOCUMENTO_PRODUTO ===
            docConfig.ID_DOCUMENTO_PRODUTO,
        descricaoGetter: (doc) =>
            (doc as IDocumentoProduto).DS_DOCUMENTO_PRODUTO,
        tipoDocumentoGetter: (doc) =>
            (doc as IDocumentoProduto).DS_TIPO_DOCUMENTO,
    },

    UNIDADE: {
        key: "documentosUnidade",
        objBaseGetter: (doc) => ({
            ID_DOCUMENTO_PRODUTO: (doc as IDocumentoProduto)
                .ID_DOCUMENTO_PRODUTO,
            FL_DOCUMENTO_FILHO: true,
        }),
        find: (docConfig, doc) =>
            (doc as IDocumentoProduto).ID_DOCUMENTO_PRODUTO ===
            docConfig.ID_DOCUMENTO_PRODUTO,
        descricaoGetter: (doc) =>
            (doc as IDocumentoProduto).DS_DOCUMENTO_PRODUTO,
        tipoDocumentoGetter: (doc) =>
            (doc as IDocumentoProduto).DS_TIPO_DOCUMENTO,
    },
};

export default function TabelaInserirDocumentoConfig(
    props: ITabelaInserirDocumentoConfigProps
) {
    const contexto = useEditarConfigDeEnvelopeContext();
    const documentosVinculados = contexto.documentosConfigEnvelope;
    const { key, objBaseGetter, find, descricaoGetter, tipoDocumentoGetter } =
        objTipoDocumento[props.tipoDocumento];
    const reqDocumentos = contexto[key];

    return (
        <OrSpinner
            loading={reqDocumentos.loading}
            wrapperLoadingClasses="w-100 d-flex justify-content-center"
            loadingColor="primary"
        >
            {reqDocumentos.lst?.map((documento) => {
                const documentoVinculado =
                    contexto.documentosConfigEnvelope.lst.find((d) =>
                        find(d, documento)
                    );
                return (
                    <DocumentoASerInseridoNaConfiguracao
                        descricao={descricaoGetter(documento)}
                        idVinculado={
                            documentoVinculado?.ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO
                        }
                        configEnvelopeDocumentoBase={{
                            ...documentoVinculado,
                            ...objBaseGetter(documento),
                            ID_ENVELOPE_DOCUSIGN_CONFIG:
                                contexto.idConfigEnvelope,
                        }}
                        updateList={documentosVinculados.update}
                        tipoDocumento={tipoDocumentoGetter(documento)}
                    />
                );
            })}
        </OrSpinner>
    );
}
